<template>
  <v-row>
    <v-col xs="12" md="3">
      <v-card class="elevation-0" outlined>
        <v-card-title>Pending</v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-for="(p, index) in getPendingProposals" :key="index">
              <v-card class="elevation-0" outlined>
                <v-card-title>{{ p.title }} - {{ getClientById(getProposalClient(p.id).id).name }}</v-card-title>
                <v-card-text>{{ getProposalTotal(p.id) }}</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col xs="12" md="3">
      <v-card class="elevation-0" outlined>
        <v-card-title>Approved</v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-for="(p, index) in getApprovedProposals" :key="index">
              <v-card class="elevation-0" outlined>
                <v-card-title>{{ p.title }} - {{ getClientById(getProposalClient(p.id).id).name }}</v-card-title>
                <v-card-text>{{ getProposalTotal(p.id) }}</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col xs="12" md="3">
      <v-card class="elevation-0" outlined>
        <v-card-title>Invoiced</v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-for="(p, index) in getInvoicedProposals" :key="index">
              <v-card class="elevation-0" outlined>
                <v-card-title>{{ p.title }} - {{ getClientById(getProposalClient(p.id).id).name }}</v-card-title>
                <v-card-text>{{ getProposalTotal(p.id) }}</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col xs="12" md="3">
      <v-card class="elevation-0" outlined>
        <v-card-title>Finished</v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-for="(p, index) in getFinishedProposals" :key="index">
              <v-card class="elevation-0" outlined>
                <v-card-title>{{ p.title }} - {{ getClientById(getProposalClient(p.id).id).name }}</v-card-title>
                <v-card-text>{{ getProposalTotal(p.id) }}</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({}),
  computed: {
    ...mapGetters([
      "getPendingProposals",
      "getApprovedProposals",
      "getInvoicedProposals",
      "getFinishedProposals",
      "getProposalTotal",
      "getProposalClient",
      "getClientById"
    ])
  },
  methods: {
    ...mapActions(["loadAllProposals"])
  }
};
</script>
